import React from 'react';

import { CompassIcon } from '@atlaskit/logo';

export const CompassBlueIcon: React.FunctionComponent = () => (
	<CompassIcon appearance="brand" size="small" />
);
